<template>
    <div class="mcall">
        <div class="call">
            <h6>微涟科技有限公司</h6>
            <p><img src="../../assets/phoneimg/qq.png" alt="">83809111</p>
            <span>微信咨询</span>
            <img src="/site_static/pimg/weixin.jpg" alt="">
            <i>服务热线</i>
            <b>024-67765666</b>
        </div>
        <span>	微涟科技有限公司 <br>辽ICP备18009739号</span>
    </div>

</template>
<script>
    export default {
        name: 'call'
    }
</script>
<style scoped>
    .mcall>span{
        text-align: center;
        color: #afbad2;
        line-height: 1.1875rem;
        position: absolute;
        top: 36rem;
        width: 100%;
        left: 0;
        font-size: .75rem;
        transform: scale(.84);
    }
    .call{
        position: absolute;
        background: #fff;
        width: 18.75rem;
        height: 30.375rem;
        box-shadow: 0 0.15625rem 1rem rgba(7,88,188,.1);
        left: 0;
        right: 0;
        margin: auto;
        top: 2rem;
        display: flex;
        flex-wrap: wrap;
        margin-top: 2rem;
    }
    .call:before{
        position: absolute;
        top: -10.9375rem;
        left: -7.8125rem;
        width: 18.75rem;
        border-radius: 50%;
        background: #fb6638;
        content: "";
        height: 18.75rem;
        opacity: .1;
    }
    .call>h6{
        font-size: 1rem;
        top: 3rem;
        color: #3b426b;
        font-weight: 600;
        width: 100%;
        text-align: center;
        position: absolute;
        left: 0;
        right: 0;
        margin: auto;
    }
    .call>p{
        width: 9.375rem;
        height: 3.0625rem;
        line-height: 3.0625rem;
        border-top: 1px solid #eee;
        border-bottom: 1px solid #eee;
        display: flex;
        justify-content: center;
        top: 5.96875rem;
        text-align: center;
        position: absolute;
        left: 0;
        right: 0;
        margin: auto;
    }
    .call>p>img{
        width: .875rem;
        height: .9375rem;
        margin: 1.03125rem .5625rem 0 0;
    }
    .call>span{
        font-size: .875rem;
        color: #333;
        top: 11.03125rem;
        line-height: .875rem;
        width: 100%;
        text-align: center;
        position: absolute;
        left: 0;
        right: 0;
        margin: auto;
    }
    .call>img{
        width: 8.125rem;
        height: 8.125rem;
        top: 12.84375rem;
        text-align: center;
        position: absolute;
        left: 0;
        right: 0;
        margin: auto;
    }
    .call>i{
        font-size: .875rem;
        color: #333;
        top: 24.34375rem;
        line-height: .875rem;
        width: 100%;
        text-align: center;
        position: absolute;
        left: 0;
        right: 0;
        margin: auto;
        font-style:normal
    }
    .call>b{
        font-size: .875rem;
        color: #fb6638;
        bottom: 3.3125rem;
        width: 100%;
        text-align: center;
        position: absolute;
        left: 0;
        right: 0;
        margin: auto;
    }

</style>



// WEBPACK FOOTER //
// src/components/phone/call.vue